import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import TooltipClient from '@/components/TooltipClient';

/**
 * Blok adapter for a standalone tooltip an editor can drop into any content
 * area. The popover's content holds nested bloks (server components), so they're
 * rendered here and handed to the client component — the same split as
 * ToggleTarget / ToggleTargetClient. TooltipClient stays presentational so other
 * components can reuse it directly (e.g. the pricing cards' price row).
 */
const Tooltip = ({ blok }) => (
  <div {...storyblokEditable(blok)} className="inline-block">
    <TooltipClient icon={blok.icon}>
      {(blok.body || []).map((nestedBlok) => (
        <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </TooltipClient>
  </div>
);

export default Tooltip;
